import { text_colorTextSecondary } from 'ext-ui/style/colors'
import { spacing } from 'ext-ui/style/spacing'
import {
  font_family_weight_regular,
  font_size_md,
} from 'ext-ui/style/typography'
import { css } from 'styled-components'

/**
 * The section cards themselves are `ext-ui`'s `Box` — its `default` variant is
 * the bordered, shadowless container the design calls for, and its 20px/24px
 * padding matches the spec exactly. Only the stack between them lives here.
 */
export const sections = css`
  display: flex;
  flex-direction: column;
  gap: ${spacing(9)};
`

/**
 * Section-level loading and error renders.
 *
 * Deliberately the same shapes `ActivityFeed` uses for its own states — the two
 * Card Management tabs sit on the same page, and a user switching between them
 * should not meet two different treatments of "we are fetching" and "that
 * failed".
 */
export const message = css`
  padding: ${spacing(6)} ${spacing(2)};
  text-align: center;
  font-size: ${font_size_md};
  font-family: ${font_family_weight_regular};
  color: ${text_colorTextSecondary};
`

export const errorState = css`
  display: flex;
  flex-direction: column;
  align-items: center;

  > p {
    padding-bottom: ${spacing(2)};
  }
`
